import { render, staticRenderFns } from "./CervedItem.vue?vue&type=template&id=4bf49553&scoped=true&"
import script from "./CervedItem.vue?vue&type=script&lang=ts&"
export * from "./CervedItem.vue?vue&type=script&lang=ts&"
import style0 from "./CervedItem.vue?vue&type=style&index=0&id=4bf49553&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf49553",
  null
  
)

export default component.exports